import CodeEditor from "components/CodeEditor";
import { useCheckFileMaxSize } from "components/Environment/useCheckFileMaxSize";
import { EmptystateLockColored, ErrorCircleColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { ConfigElement } from "types/generated";

type EnvironmentMountedFilesTableFileRowProps = {
  file: ConfigElement;
};

const EnvironmentMountedFilesTableFileRow = ({
  file,
}: EnvironmentMountedFilesTableFileRowProps) => {
  const { fileContent, exceedsFileSize, isFileBroken } = useCheckFileMaxSize(file.value ?? "");

  return (
    <Box padding="x-large" fullWidth>
      {exceedsFileSize && (
        <EmptyState
          icon={ErrorCircleColored}
          title="File too large"
          caption="We can't display file preview. File is either larger than 0,5MB or in a wrong format."
        />
      )}
      {!exceedsFileSize && isFileBroken && (
        <EmptyState
          margin="large 0"
          icon={ErrorCircleColored}
          title="We couldn't load the file."
          caption="Please try again later."
        />
      )}
      {!exceedsFileSize && !isFileBroken && file.writeOnly && (
        <EmptyState
          margin="large 0"
          icon={EmptystateLockColored}
          title="This is a secret file"
          caption="This means you can not edit it, only overwrite or upload a new one."
        />
      )}
      {!exceedsFileSize && !isFileBroken && !file.writeOnly && (
        <CodeEditor
          autoHeight
          maxAutoHeight={500}
          language="json"
          body={fileContent}
          readOnly
          options={{ overviewRulerLanes: 0 }}
        />
      )}
    </Box>
  );
};

export default EnvironmentMountedFilesTableFileRow;
